import * as actions from '../../redux/actions';

import { ThemeFiveFleetSection, ThemeFiveIconsSection, ThemeFiveTitles } from '../..';

import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import ThemeFiveOfficeSection from '../../ThemeFiveOfficeSection';

const ThemeFiveAboutUsScreen = ({ history, home }) => {
  const operator = CommonService.getLocal('op') || home.operator;

  const createMarkup = data => {
    return { __html: data };
  };

const getSmallandBoldHeading = () => {
  if (
    operator &&
    (operator.operator_name === 'centraltour' || operator.operator_name === 'tepual')
  ) {
    return { smallHeading: 'Descubre', boldHeading: 'NUESTRAS FLOTA' };
  }
  return { smallHeading: 'Conoce', boldHeading: 'NUESTRAS OFICINAS' };
};

  const getFleetSection = () => {
    const name = operator && operator.operator_name;

    if (
      name === 'tepual' ||
      name === 'expressonorte' ||
      name === 'trrass' ||
      name === 'centraltour'
    ) {
      return (
        <React.Fragment>
          <ThemeFiveTitles
            className="mt-4"
            smallHeading="Conoce"
            boldHeading="NUESTROS SERVICIOS"
          />

          <ThemeFiveIconsSection />
          <ThemeFiveTitles smallHeading={getSmallandBoldHeading().smallHeading} boldHeading={getSmallandBoldHeading().boldHeading} />
          {name === 'tepual' || name === 'centraltour' ? (
            <ThemeFiveFleetSection />
          ) : (
            <ThemeFiveOfficeSection />
          )}
        </React.Fragment>
      );
    }
    //  else if (name === 'bahiaazul') {
    //   return null;
    // }

    return null;
  };

  const getTrrassSpecificAboutUS = () => {
    return (
      <div>
        <div className="new-container " style={{ display: 'flex', gap: '50px', marginTop: 60 }}>
          <div
            dangerouslySetInnerHTML={createMarkup(
              operator && operator.about_us ? operator.about_us.split('///')[1] : '',
            )}
            className="lh-1-3 font11 justify-text "
            style={{ flex: 1 }}
          />

          <div style={{ flex: 1 }}>
            <div
              dangerouslySetInnerHTML={createMarkup(
                operator && operator.about_us ? operator.about_us.split('///')[2] : '',
              )}
              className="lh-1-3 font11 justify-text "
              style={{ flex: 1 }}
            />
          </div>
        </div>

        <div className="new-container " style={{ display: 'flex', gap: '50px', marginTop: 30 }}>
          <div
            dangerouslySetInnerHTML={createMarkup(
              operator && operator.about_us ? operator.about_us.split('///')[3] : '',
            )}
            className="lh-1-3 font11 justify-text "
            style={{ flex: 1 }}
          />

          <div style={{ flex: 1 }}>
            <div
              dangerouslySetInnerHTML={createMarkup(
                operator && operator.about_us ? operator.about_us.split('///')[4] : '',
              )}
              className="lh-1-3 font11 justify-text "
              style={{ flex: 1 }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="">
      <KuposHelmet />

      <HeroSection
        heroImage={getIcons('aboutUsBanner', operator)}
        title={'Nosotros'}
        height={'30vh'}
        description={'Home / Nosotros'}
      />

      <div className="new-container " style={{ display: 'flex', gap: '20px',
        marginTop: operator.operator_name === 'jeldres' ? 50 : 0}}>
        <div
          dangerouslySetInnerHTML={createMarkup(
            operator && operator.about_us && operator.operator_name === 'trrass'
              ? operator.about_us.split('///')[0]
              : operator.about_us,
          )}
          className="lh-1-3 font11 justify-text "
          style={{ flex: 1 }}
        />

        <div style={{ flex: 0.7,  marginLeft: operator.operator_name === 'jeldres' ? 30 : 0 }}>
          <img
            style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}
            src={getIcons('aboutUsImage', operator)}
            alt=""
          />
        </div>
      </div>
      

      
      {operator.operator_name ==='jeldres' ?
      (<div style={{ marginTop: 40 }}>
      <ThemeFiveTitles className="mb-4" smallHeading="Conoce" boldHeading="NUESTROS SERVICIOS" />
      <div style={{ marginLeft: -50 }}><ThemeFiveIconsSection /></div>
			</div>) :null}

      {operator && operator.operator_name && operator.operator_name === 'trrass'
        ? getTrrassSpecificAboutUS()
        : null}

      {getFleetSection()}
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFiveAboutUsScreen);



// WEBPACK FOOTER //
// ./src/features/themes/theme5/ThemeFivePages/ThemeFiveAboutUsScreen.js